
import React from 'react';

// -----------------------------------------------------------
//  FilterSelectorsMixin
// -----------------------------------------------------------
const FilterSelectorsMixin = {
  componentDidUpdate() {
    // Calculate right angle for disabled option css:
    // Math.atan(h / w) * 180 / 3.14159 <= Formula
    if (this.props.disabled) {
      const option = $(this.refs.option);

      const deg = Math.atan(option.outerHeight() / option.outerWidth()) * (180 / 3.14159) - 1;
      const lineWidth = Math.sqrt(option.outerWidth() * option.outerWidth() + option.outerHeight() * option.outerHeight());

      $(this.refs.disabledOverlay).css({
        '-webkit-transform': `rotate(-${deg}deg)`,
        '-moz-transform': `rotate(-${deg}deg)`,
        '-ms-transform': `rotate(-${deg}deg)`,
        '-o-transform': `rotate(-${deg}deg)`,
        transform: `rotate(-${deg}deg)`,
        '-webkit-transform-origin': 'bottom left',
        '-moz-transform-origin': 'bottom left',
        '-ms-transform-origin': 'bottom left',
        '-o-transform-origin': 'bottom left',
        'transform-origin': 'bottom left',
        width: `${lineWidth}px`,
      });
    }
  },
  disabledOverlay() {
    return this.props.disabled && <div className="disabled-line" ref="disabledOverlay" />;
  },
  handleSelected() {
    this.props.onSelected(this.props.title);
  },
  handleMouseEnter() {
    this.props.onMouseEnter(this.props.title);
  },
  handleMouseLeave() {
    this.props.onMouseLeave(this.props.title);
  },
};

export default FilterSelectorsMixin;
